import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import { useContext } from 'react';
import { useParams } from 'react-router';
import { useRoutes } from '../../../../hooks/useRoutes';
import ModuleContext from '../../_contexts/ModuleContext';

export default function SubModuleBreadcrumb() {
  const { selectedModule } = useContext(ModuleContext);
  const { buildAbsolutePath } = useRoutes();
  const { subjectSlug, methodSlug, moduleSlug } = useParams();

  if (!subjectSlug || !methodSlug || !moduleSlug || !selectedModule) return null;

  return (
    <Breadcrumbs.Item
      avatarImage={
        selectedModule.styling?.logo ? (
          <AvatarImage name={selectedModule.niceName} src={selectedModule.styling?.logo} />
        ) : undefined
      }
      to={buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.CONTENT.TOC'], {
        subjectSlug,
        methodSlug,
        moduleSlug,
        selectedModuleSlug: selectedModule.slug,
        nodeId: '',
      })}
    >
      {selectedModule.niceName}
    </Breadcrumbs.Item>
  );
}
